export const TERMS_AND_AGREEMENT_ROUTE = {
    title: 'Terms and Agreement',
    name: 'terms-and-agreement',
};
export const TERMS_AND_AGREEMENT_EDIT_ROUTE = {
    title: 'Edit Terms and Agreement',
    name: 'terms-and-agreement-edit',
};
export const PRODUCT_MARKETPLACE_ROUTE = {
    title: 'Product Marketplace',
    name: 'product-marketplace',
};
export const PRODUCT_SHOWCASE_CATALOG_ROUTE = {
    title: 'Product Showcase Catalog',
    name: 'product-showcase-catalog',
};
export const ADS_MANAGER_ROUTE = {
    title: 'Ads Manager',
    name: 'ads-manager',
};
export const CREATE_AD_ROUTE = {
    title: 'Create New Ad',
    name: 'create-ad',
};
export const EDIT_AD_ROUTE = {
    title: 'Edit Existing Ad',
    name: 'edit-ad',
};
